import { render, staticRenderFns } from "./Configoptions.vue?vue&type=template&id=65a7f5f2&scoped=true&"
import script from "./Configoptions.vue?vue&type=script&lang=js&"
export * from "./Configoptions.vue?vue&type=script&lang=js&"
import style0 from "./Configoptions.vue?vue&type=style&index=0&id=65a7f5f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7f5f2",
  null
  
)

export default component.exports